export interface AppTheme {
  id: string;
  name: string;
  path: string;
  thumbnail: string;
}

export const APP_THEMES: AppTheme[] = [
  { id: 'bg0', name: 'Default', path: '', thumbnail: '' },
  { id: 'bg1', name: 'Tinapa Resort', path: '/backgrounds/bg1.jpg', thumbnail: '/backgrounds/bg1.jpg' },
  { id: 'bg2', name: 'Calabar Carnival', path: '/backgrounds/bg2.jpg', thumbnail: '/backgrounds/bg2.jpg' },
  { id: 'bg3', name: 'Calabar Carnival', path: '/backgrounds/bg3.jpg', thumbnail: '/backgrounds/bg3.jpg' },
  { id: 'bg4', name: 'Calabar Calabar', path: '/backgrounds/bg4.jpg', thumbnail: '/backgrounds/bg4.jpg' },
  { id: 'bg5', name: 'Obudu Cattle Ranch', path: '/backgrounds/bg5.webp', thumbnail: '/backgrounds/bg5.webp' },
  { id: 'bg6', name: "Governor's Office", path: '/backgrounds/bg6.jpg', thumbnail: '/backgrounds/bg6.jpg' },
  { id: 'bg7', name: 'Obudu Mountain Resort', path: '/backgrounds/bg7.webp', thumbnail: '/backgrounds/bg7.webp' },
  { id: 'bg8', name: 'Mighty Hands of Calabar', path: '/backgrounds/bg8.jpg', thumbnail: '/backgrounds/bg8.jpg' },
  { id: 'bg9', name: 'Mighty Hands of Calabar II', path: '/backgrounds/bg9.jpg', thumbnail: '/backgrounds/bg9.jpg' },
  { id: 'bg10', name: 'Calabar Carnival II', path: '/backgrounds/bg10.webp', thumbnail: '/backgrounds/bg10.webp' },
  { id: 'bg11', name: 'Calabar My Calabar', path: '/backgrounds/bg11.jpg', thumbnail: '/backgrounds/bg11.jpg' },
  { id: 'bg12', name: 'Calabar International Conference Center', path: '/backgrounds/bg12.jpg', thumbnail: '/backgrounds/bg12.jpg' },
];

export function normalizeThemePath(path: string | null | undefined): string | null {
  if (!path || !path.trim()) return null;
  return path;
}

export function isDefaultTheme(theme: AppTheme): boolean {
  return !theme.path;
}

export function isThemeSelected(theme: AppTheme, currentTheme: string | null): boolean {
  if (isDefaultTheme(theme)) return !normalizeThemePath(currentTheme);
  return currentTheme === theme.path;
}
